export const faqs = {
  marketingSite: {
    categories: [
      {
        title: "Program",
        faqs: [
          {
            answer:
              "Conceive is a 24/7 fertility, pregnancy, and postpartum support platform that connects you with real humans—nurses, fertility coaches, dietitians, and lactation experts—when questions come up between appointments.<br/><br/>We don't replace your doctor. We work alongside your care team to help you make sense of what's happening, prepare for next steps, and feel supported through the parts of the journey that usually happen outside the clinic: nights, weekends, waiting periods, transitions, and moments of uncertainty.<br/><br/>Members use Conceive for everything from understanding test results and treatment timelines to managing anxiety, navigating decisions, preparing for birth, and getting lactation support after delivery—without spiraling or waiting days for a portal response.",
            question: "What is Conceive?",
          },
          {
            answer:
              "Conceive supports people:<br/><br/>- Preserving their fertility<br/>- Trying to conceive (with or without treatment)<br/>- Doing timed intercourse, IUI, IVF, or egg freezing<br/>- Navigating surrocacy and/or using donor tissue<br/>- Navigating pregnancy<br/>- Looking for clarity, reassurance, or a second set of eyes between appointments<br/><br/>You don't need to be doing IVF (or planning to) to benefit from Conceive.",
            question: "Who is Conceive for?",
          },
          {
            answer:
              "No. Conceive works alongside your medical team.<br/><br/>We help you:<br/>- Understand recommendations and results<br/>- Prepare questions for appointments<br/>- Decide what matters right now vs. what can wait<br/>- Navigate next steps with more confidence<br/><br/>Your medical care stays with your providers. We focus on continuity, context, and support between visits.",
            question: "Does Conceive replace my doctor or clinic?",
          },
          {
            answer:
              "Yes. Everything you share with Conceive is private and secure.<br/><br/>We never sell your data, and we don't share personal information without your consent. Confidentiality and trust are foundational to how we operate.",
            question: "Is my information kept confidential?",
          },
        ],
      },
      {
        title: "Care Team & Support",
        faqs: [
          {
            answer:
              "You'll interact with a Care Team that may include:<br/><br/>- Fertility, L&D, OB nurses<br/>- Fertility and pregnancy coaches<br/>- Dietitians<br/>- Lactation specialists<br/>- Other vetted specialists, as needed<br/><br/>All support is grounded in evidence-based medicine and delivered with empathy and context.",
            question: "Who will I be talking to?",
          },
          {
            answer:
              "Conceive is designed for real-time support. You can expect to receive responses within 10 minutes",
            question: "How quickly will I hear back?",
          },

          {
            answer:
              "Premium members have access to two scheduled 1:1 sessions each month—one with a coach and one with a nurse or dietician—to help talk through questions, decisions, and next steps. Additional sessions can be purchased as needed.",
            question: "Can I schedule calls or video visits?",
          },
          {
            answer:
              "Our coaches act as approachable advocates and empathetic cheerleaders. They've all been through fertility journeys and pregnancies themselves, so they love to share personal insights where appropriate. They're supported by nurses and other clinicians to make up an essential part of your care team.",
            question: "Who are the coaches?",
          },
          {
            answer:
              "Interested in becoming a Conceive coach or provider? We'd love to make that happen! Fill out our <a href='https://lj50ptwf9ra.typeform.com/to/xkJcZYvm?typeform-source=weconceive.com' target='_blank'>coach</a> or <a href='https://lj50ptwf9ra.typeform.com/to/l6nXnRfm?typeform-source=weconceive.com' target='_blank'>provider</a> application and we will be in touch.",
            question: "How do I apply to be a Conceive coach, nurse, or dietician?",
          },
        ],
      },
      {
        title: "Membership & Access",
        faqs: [
          {
            answer: "Conceive is offered through:<br/>- Direct-to-consumer memberships, and/or<br/>- Access provided through your fertility clinic<br/><br/>If you're unsure what's included, our team can help clarify.",
            question: "How does membership work?",
          },
          {
            answer: "Conceive offers two membership options:<br/>- Conceive Plus starts at $43/month<br/>- Conceive Premium starts at $116/month<br/><br/>In some cases, Conceive is included as part of your care through a fertility clinic, at no additional cost to you. If you're unsure whether access is included, your clinic or our team can help confirm.",
            question: "How much does Conceive cost?",
          },
          {
            answer: "Unfortunately, Conceive is not covered by insurance at this time. You may request a receipt for your Conceive program and check with your insurance provider or FSA/HSA provider to see if Conceive membership can be covered.",
            question: "Is Conceive covered by insurance?",
          },
          {
            answer: "We want you to be completely happy with your Conceive experience. If you need to cancel your subscription, you can do so at any time by clicking the icon in the upper right hand corner and going to the \"Settings\" page. Conceive offers a monthly auto-renewing subscription so you will continue to have access to your subscription through the end of the pay period.",
            question: "What if I want to cancel my Conceive membership?",
          },
        ],
      },
      {
        title: "Library",
        faqs: [
          {
            answer:
              "One of the benefits of Conceive membership is access to an expanded library of exclusive resources and materials with info that can really ramp-up your journey. That's why some articles are only accessible for members. Your best option if you'd like to read them is to sign up to a membership. You can explore your options here.",
            question: "Why are some articles locked?",
          },
        ],
      },
      {
        title: "General",
        faqs: [
          {
            answer:
              "Conceive is currently available to adults 18+ located in the United States.",
            question: "Where is Conceive available?",
          },
          {
            answer:
              "Reach out anytime at <a href='mailto:support@weconceive.com'>support@weconceive.com</a> —or, if you're already a member, just text us directly. That's what we're here for.",
            question: "What if my question isn't answered here?",
          },
        ],
      },
      {
        title: "Conceive Assess",
        faqs: [
          {
            answer:
              "Conceive Assess is a guided fertility assessment designed to help you understand where you are right now—and what to consider next.<br/><br/>It combines at-home or lab testing, expert review, and personalized guidance from the Conceive Care Team to give you clearer insight into your fertility health and any next steps.",
            question: "What is Conceive Assess?",
          },
          {
            answer:
              "Conceive Assess is a good fit if you:<br/><br/>- Want a clearer picture of your fertility health<br/>- Are thinking about trying soon but aren't sure where to start<br/>- Have been trying and want more context before next steps<br/>- Are considering fertility preservation or treatment and want baseline data<br/><br/>You don't need to be actively trying or planning IVF to use Conceive Assess.",
            question: "Who is Conceive Assess for?",
          },
          {
            answer:
              "Conceive Assess includes:<br/><br/>- At-home or local lab fertility testing<br/>- Detailed, easy-to-understand results within days<br/>- Doctor review of your results<br/>- A call with one of Conceive's fertility nurses to dive deeper and talk about potential next steps",
            question: "What's included in Conceive Assess?",
          },
        ],
      },
    ],
  },
  memberSite: {
    categories: [
      {
        title: "Program",
        faqs: [
          {
            answer:
              "Conceive is a 24/7 fertility, pregnancy, and postpartum support platform that connects you with real humans—nurses, fertility coaches, dietitians, and lactation experts—when questions come up between appointments.<br/><br/>We don't replace your doctor. We work alongside your care team to help you make sense of what's happening, prepare for next steps, and feel supported through the parts of the journey that usually happen outside the clinic: nights, weekends, waiting periods, transitions, and moments of uncertainty.<br/><br/>Members use Conceive for everything from understanding test results and treatment timelines to managing anxiety, navigating decisions, preparing for birth, and getting lactation support after delivery—without spiraling or waiting days for a portal response.",
            question: "What is Conceive?",
          },
          {
            answer:
              "Conceive supports people:<br/><br/>- Preserving their fertility<br/>- Trying to conceive (with or without treatment)<br/>- Doing timed intercourse, IUI, IVF, or egg freezing<br/>- Navigating surrocacy and/or using donor tissue<br/>- Navigating pregnancy<br/>- Looking for clarity, reassurance, or a second set of eyes between appointments<br/><br/>You don't need to be doing IVF (or planning to) to benefit from Conceive.",
            question: "Who is Conceive for?",
          },
          {
            answer:
              "No. Conceive works alongside your medical team.<br/><br/>We help you:<br/>- Understand recommendations and results<br/>- Prepare questions for appointments<br/>- Decide what matters right now vs. what can wait<br/>- Navigate next steps with more confidence<br/><br/>Your medical care stays with your providers. We focus on continuity, context, and support between visits.",
            question: "Does Conceive replace my doctor or clinic?",
          },
          {
            answer:
              "Yes. Everything you share with Conceive is private and secure.<br/><br/>We never sell your data, and we don't share personal information without your consent. Confidentiality and trust are foundational to how we operate.",
            question: "Is my information kept confidential?",
          },
        ],
      },
      {
        title: "Care Team & Support",
        faqs: [
          {
            answer:
              "You'll interact with a Care Team that may include:<br/><br/>- Fertility, L&D, OB nurses<br/>- Fertility and pregnancy coaches<br/>- Dietitians<br/>- Lactation specialists<br/>- Other vetted specialists, as needed<br/><br/>All support is grounded in evidence-based medicine and delivered with empathy and context.",
            question: "Who will I be talking to?",
          },
          {
            answer:
              "Conceive is designed for real-time support. You can expect to receive responses within 10 minutes",
            question: "How quickly will I hear back?",
          },

          {
            answer:
              "Premium members have access to two scheduled 1:1 sessions each month—one with a coach and one with a nurse or dietician—to help talk through questions, decisions, and next steps. Additional sessions can be purchased as needed.",
            question: "Can I schedule calls or video visits?",
          },
          {
            answer:
              "Our coaches act as approachable advocates and empathetic cheerleaders. They've all been through fertility journeys and pregnancies themselves, so they love to share personal insights where appropriate. They're supported by nurses and other clinicians to make up an essential part of your care team.",
            question: "Who are the coaches?",
          },
          {
            answer:
              "Interested in becoming a Conceive coach or provider? We'd love to make that happen! Fill out our <a href='https://lj50ptwf9ra.typeform.com/to/xkJcZYvm?typeform-source=weconceive.com' target='_blank'>coach</a> or <a href='https://lj50ptwf9ra.typeform.com/to/l6nXnRfm?typeform-source=weconceive.com' target='_blank'>provider</a> application and we will be in touch.",
            question: "How do I apply to be a Conceive coach, nurse, or dietician?",
          },
        ],
      },
      {
        title: "Membership & Access",
        faqs: [
          {
            answer: "Conceive is offered through:<br/>- Direct-to-consumer memberships, and/or<br/>- Access provided through your fertility clinic<br/><br/>If you're unsure what's included, our team can help clarify.",
            question: "How does membership work?",
          },
          {
            answer: "Conceive offers two membership options:<br/>- Conceive Plus starts at $43/month<br/>- Conceive Premium starts at $116/month<br/><br/>In some cases, Conceive is included as part of your care through a fertility clinic, at no additional cost to you. If you're unsure whether access is included, your clinic or our team can help confirm.",
            question: "How much does Conceive cost?",
          },
          {
            answer: "Unfortunately, Conceive is not covered by insurance at this time. You may request a receipt for your Conceive program and check with your insurance provider or FSA/HSA provider to see if Conceive membership can be covered.",
            question: "Is Conceive covered by insurance?",
          },
          {
            answer: "We want you to be completely happy with your Conceive experience. If you need to cancel your subscription, you can do so at any time by clicking the icon in the upper right hand corner and going to the \"Settings\" page. Conceive offers a monthly auto-renewing subscription so you will continue to have access to your subscription through the end of the pay period.",
            question: "What if I want to cancel my Conceive membership?",
          },
        ],
      },
      {
        title: "Library",
        faqs: [
          {
            answer:
              "One of the benefits of Conceive membership is access to an expanded library of exclusive resources and materials with info that can really ramp-up your journey. That's why some articles are only accessible for members. Your best option if you'd like to read them is to sign up to a membership. You can explore your options here.",
            question: "Why are some articles locked?",
          },
        ],
      },
      {
        title: "General",
        faqs: [
          {
            answer:
              "Conceive is currently available to adults 18+ located in the United States.",
            question: "Where is Conceive available?",
          },
          {
            answer:
              "Reach out anytime at <a href='mailto:support@weconceive.com'>support@weconceive.com</a> —or, if you're already a member, just text us directly. That's what we're here for.",
            question: "What if my question isn't answered here?",
          },
        ],
      },
      {
        title: "Conceive Assess",
        faqs: [
          {
            answer:
              "Conceive Assess is a guided fertility assessment designed to help you understand where you are right now—and what to consider next.<br/><br/>It combines at-home or lab testing, expert review, and personalized guidance from the Conceive Care Team to give you clearer insight into your fertility health and any next steps.",
            question: "What is Conceive Assess?",
          },
          {
            answer:
              "Conceive Assess is a good fit if you:<br/><br/>- Want a clearer picture of your fertility health<br/>- Are thinking about trying soon but aren't sure where to start<br/>- Have been trying and want more context before next steps<br/>- Are considering fertility preservation or treatment and want baseline data<br/><br/>You don't need to be actively trying or planning IVF to use Conceive Assess.",
            question: "Who is Conceive Assess for?",
          },
          {
            answer:
              "Conceive Assess includes:<br/><br/>- At-home or local lab fertility testing<br/>- Detailed, easy-to-understand results within days<br/>- Doctor review of your results<br/>- A call with one of Conceive's fertility nurses to dive deeper and talk about potential next steps",
            question: "What's included in Conceive Assess?",
          },
        ],
      },
    ],
  },
};
